import { render, staticRenderFns } from "./SiteContentService.vue?vue&type=template&id=39f5486a&"
import script from "./SiteContentService.vue?vue&type=script&lang=js&"
export * from "./SiteContentService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports